// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DonationWidgetBlock_wrapper__iAqgg","widget":"DonationWidgetBlock_widget__q__AI"};